import { useTranslate } from "ra-core";

import useAppBarHeight from "../misc/useAppBarHeight";

export const ContactEmpty = () => {
  const appbarHeight = useAppBarHeight();
  const translate = useTranslate();

  return (
    <div
      className="flex flex-col justify-center items-center gap-3"
      style={{
        height: `calc(100dvh - ${appbarHeight}px)`,
      }}
    >
      <img
        src="./img/empty.svg"
        alt={translate("resources.contacts.empty.title")}
      />
      <div className="flex flex-col gap-0 items-center">
        <h6 className="text-lg font-bold">
          {translate("resources.contacts.empty.title")}
        </h6>
        <p className="text-sm text-muted-foreground text-center mb-4 max-w-sm">
          {translate("resources.contacts.empty.bc_sync_description", {
            _: "Contacts are synced from Business Central. Check Settings → BC Sync or wait for the nightly sync.",
          })}
        </p>
      </div>
    </div>
  );
};
